'use client'

import ContactForm from "@/components/forms/contactForm"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import { ContactFormData } from "@/lib/schemas/contactFormSchema"
import { useTranslations } from "next-intl"
import { ReactNode, useState } from "react"

interface ContactDialogProps {
      children: ReactNode
      onFormSubmitted?: (data: ContactFormData) => void
}

export function ContactDialog({ children, onFormSubmitted }: ContactDialogProps) {
      const t = useTranslations('dialogs.contact');
      const [open, setOpen] = useState(false)

      const handleFormSubmitted = (data: ContactFormData) => {
            if (onFormSubmitted) {
                  onFormSubmitted(data)
            }
            setOpen(false)
      }

      return (
            <Dialog open={open} onOpenChange={setOpen}>
                  <DialogTrigger asChild>
                        {children}
                  </DialogTrigger>
                  <DialogContent className="sm:max-w-[500px] overflow-hidden">
                        <DialogHeader>
                              <DialogTitle>{t('title')}</DialogTitle>
                        </DialogHeader>
                        <ContactForm onFormSubmitted={handleFormSubmitted} />
                  </DialogContent>
            </Dialog>
      )
}

export default ContactDialog 